module.exports = __webpack_public_path__ + "static/img/SearchDetailBorn4.5b4dc5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailBorn4.png
// module id = 712
// module chunks = 0